
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/karaoke",
      function () {
        return require("private-next-pages/karaoke.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/karaoke"])
      });
    }
  